import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const BannerContainer = styled.div`
  background-color: #1a202c; /* Deeper contrast */
  color: #ffffff;
  padding: 12px 20px;
  text-align: center;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: relative;
  z-index: 101;
`;

const BannerLink = styled(Link)`
  color: #63b3ed; /* Lighter blue for visibility on dark */
  text-decoration: none;
  font-weight: 700;
  margin-left: 8px;

  &:hover {
    text-decoration: underline;
    color: #90cdf4;
  }
`;

const Banner = () => {
  return (
    <BannerContainer>
      Notice: Gainsta ceased operations in late 2022 due to platform API deprecation. Access to automation features is no longer available.
      <BannerLink to="/shutdown">Read the Official Notice</BannerLink>
    </BannerContainer>
  );
};

export default Banner;
